export default __webpack_public_path__ + "static/media/settings.6b429f4f.svg";